import type { ICompany } from '@/modules/admin/company/type';
import apiClient from '@/service';
import type { CommonCodeGroup, CommonCodeResponse } from '@/types/CommonCode';
import { errorHandler } from '@/utils';
import { defineStore } from 'pinia';

export const useCommonStore = defineStore('commonStore', {
  state: () => ({
    codeCache: {} as any,
  }),
  actions: {
    async fetchCommonCodes<T extends readonly string[]>(
      groupCodes: T
    ): Promise<{ [K in T[number]]: CommonCodeGroup }> {
      const valueList = [] as string[];

      groupCodes.forEach((groupCode) => {
        if (!this.codeCache[groupCode]) {
          valueList.push(groupCode);
        }
      });

      if (valueList.length === 0) {
        return this.codeCache as { [K in T[number]]: CommonCodeGroup };
      }

      return apiClient
        .get<CommonCodeResponse>(`/common/code?valueList=${valueList.join(',')}`)
        .then(({ data: { data } }) => {
          this.codeCache = {
            ...this.codeCache,
            ...data,
          };
          return { ...this.codeCache } as { [K in T[number]]: CommonCodeGroup };
        })
        .catch((error) => {
          errorHandler(error);
          return {} as { [K in T[number]]: CommonCodeGroup };
        });
    },
    clearCache() {
      this.codeCache = {};
    },
    removeCodeGroup(groupCode: string) {
      delete this.codeCache[groupCode];
    },
    getCompanyList() {
      return apiClient.get<ICompany[]>('/company').then(({ data: { data } }) => {
        return data;
      });
    },
  },
});
